import qs from 'querystring'
import createReducer from '../../../../../util/createReducer'
import * as http from '../../../../../util/http'

//constant
const API_PREFIX = '/news'

const DEFAULT_SIZE = 10

const LIST_API = `${API_PREFIX}/list`

const RECEIVE_LIST = `NEWS_RECEIVE_LIST`

export const CHANGE_PAGE = `NEWS_CHANGE_PAGE`

export const SHOW_MODAL = `NEWS_SHOW_MODAL`

export const HIDE_MODAL = `NEWS_HIDE_MODAL`

export const CHANGE_SELECTED = `NEWS_CHANGE_SELETED`

export const CHANGE_SORT = `NEWS_CHANGE_SORT`

export const GET_UN_READ = `NEWS_GET_UN_READ`

export const CHANGE_SEARCH_VALUE = `NEWS_CHANGE_SEARCH_VALUE`

export const CHANGE_QUERY = `NEWS_CHANGE_QUERY`




//action
function getData(params,dispatch) {
    return http.get(`${LIST_API}?${qs.stringify(params)}`)
        .then(data => {
            dispatch({
                type: RECEIVE_LIST,
                data: data.data
            })
        })
}

export function getList() {
    return (dispatch,getState) => {
        const {news: {page,search,status}} = getState()
        const data = {
            page: page.index,
            size: page.size
        }
        if (search.value) {
            data['searchValue'] = search.value
        }
        if (status !== '0') {
            data['searchValue'] = status
        }
        getData(data,dispatch)
    };
}

export function remove(id) {
    return (dispatch,getState) => {
        return http.get(`${API_PREFIX}/delete?ids=${id}`)
            .then(() => {
                dispatch({type: HIDE_MODAL})
                dispatch(getList())
            })
    }
}
export function getUnReadTotal() {
    return (dispatch) => {
        return http.get(`${API_PREFIX}/no-read`).then((data)=>{
            dispatch({
                type: GET_UN_READ,
                data: data.data.total
            })
        })
    }
}

export function setRead() {
    return (dispatch,getState) => {
        const {news: {selected}} = getState()
        const id = selected.map(item => item).join(',')
        return http.get(`${API_PREFIX}/read?ids=${id}`)
            .then(() => {
                dispatch(getList())
                dispatch({type: CHANGE_SELECTED,value: []})
                dispatch(getUnReadTotal())
            })
    }
}
//reducers
const initialState = {
    list: [],
    order: 'asc',
    orderBy: '',
    selected: [],
    page: {
        index: 0,
        size: DEFAULT_SIZE
    },
    total: 0,
    showModal: {
        delete: false,
        detail: false,
        id: null,
        title: '',
        content: null
    },
    unRead: 0,
    search: {
        key: 'searchValue',
        value: ''
    },
    status: '0',
}

export default createReducer(initialState,{
    [RECEIVE_LIST]: (state,{data}) => {
        return {...state,...data}
    },
    [CHANGE_PAGE]: (state, {page}) => {
        return {...state, page}
    },
    [SHOW_MODAL]: (state,{key,id,title,content}) => {
        return {...state,showModal: {...state.showModal,[key]: true,id,title,content}}
    },
    [HIDE_MODAL]: (state) => {
        return {...state,showModal: initialState.showModal,selected: initialState.selected}
    },
    [CHANGE_SELECTED]: (state,{value}) => {
        return {...state,selected: value}
    },
    [CHANGE_SORT]: (state,{key,value}) => {
        return {...state,[key]:value}
    },
    [GET_UN_READ]: (state, {data}) => {
        return {...state, unRead: data}
    },
    [CHANGE_SEARCH_VALUE]: (state,{value}) => {
        return {...state,search: {...state.search,value}}
    },
    [CHANGE_QUERY]: (state,{value}) => {
        return {...state,status: value}
    }
})


// WEBPACK FOOTER //
// ./src/pages/home/routes/news/reducers/list.js